import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-grid p-col-12 p-formgrid"
}
const _hoisted_2 = { class: "p-field p-col-12 p-md-2 p-field-btn" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-5 p-field-btn" }
const _hoisted_4 = { class: "p-field p-col-12 p-md-5 p-field-btn" }
const _hoisted_5 = { style: {"min-width":"600px"} }
const _hoisted_6 = { class: "p-fluid p-grid p-col-12 p-formgrid" }
const _hoisted_7 = { class: "p-field p-col-12" }
const _hoisted_8 = { class: "p-field p-col-12 p-md-6 p-field-btn" }
const _hoisted_9 = { class: "p-field p-col-12 p-md-6 p-field-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_horizontal_timeline = _resolveComponent("horizontal-timeline")!
  const _component_p_button = _resolveComponent("p-button")!
  const _component_p_textarea = _resolveComponent("p-textarea")!
  const _component_p_dialog = _resolveComponent("p-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_horizontal_timeline, {
      id: _ctx.id,
      resource: _ctx.resource
    }, null, 8, ["id", "resource"]),
    (_ctx.enable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_p_button, {
              label: "Reject",
              icon: "pi pi-times-circle",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.startFeedBack())),
              class: "p-button"
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_p_button, {
              label: "Request Information",
              icon: "pi pi-info-circle",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogFlag = true)),
              class: "p-button"
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_p_button, {
              label: "Approve",
              icon: "pi pi-check-circle",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startFeedBack('APPROVE'))),
              class: "p-button"
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_p_dialog, {
      style: {"margin":"10px"},
      header: "Enter Remarks",
      visible: _ctx.dialogFlag,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogFlag) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "m-1" }, "Remarks", -1)),
              _createVNode(_component_p_textarea, {
                modelValue: _ctx.remarks,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.remarks) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                placeholder: "Enter remarks"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_p_button, {
                label: "Cancel",
                icon: "pi pi-times-circle",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFlag = false)),
                class: "p-button"
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_p_button, {
                label: "Request Information",
                icon: "pi pi-check-circle",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startFeedBack('REQUEST'))),
                class: "p-button"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}